import * as IF from "infrontjs";

import { Routine } from "../../../model/Routine";
import template from './template.html';

class RoutineSelectionIndividual extends HTMLElement
{
    static get observedAttributes()
    {
        return [ 'icon', 'weekly-frequence' ];
    }

    get weeklyFrequence()
    {
        let ret = this.getAttribute( 'weekly-frequence' );
        if ( ret )
        {
            return parseInt( ret );
        }
        else
        {
            return 0;
        }
    }

    constructor()
    {
        super();
        this._isConnected = false;
    }

    connectedCallback()
    {
        if ( false === this._isConnected )
        {
            this.root = this;
            this.app = IF.App.get();
            this.render();

            if ( false === this.hasAttribute( 'goal' ) || Routine.GOAL_DAILY !== this.getAttribute( 'goal' ) )
            {
                this.root.querySelector( '[data-id="customWeeklyFrequenceSelector"]' ).addEventListener(
                    'click',
                    () => {
                        const wfContainer = this.app.gui.getWeeklyFrequenceModalContainer();
                        wfContainer.querySelectorAll( '[data-type="weeklyFrequenceButton"]' ).forEach( btn =>
                        {
                            btn.addEventListener( 'click', () => {
                                this._onFrequenceSelection( btn.getAttribute( 'data-times' ) );
                            });
                        });
                        wfContainer.querySelector( '[data-type="modal-closer"]' ).addEventListener( 'click', () =>
                        {
                            wfContainer.querySelectorAll( '[data-type="weeklyFrequenceButton"]' ).forEach( (btn) =>
                            {
                                btn.removeEventListeners( 'click' );
                            });
                            wfContainer.querySelector( '[data-type="modal-closer"]' ).removeEventListeners( 'click' );
                            this.app.gui.hideFrequenceModal();
                        });
                        this.app.gui.showFrequenceModal( this.customWeeklyFrequencies );
                    }
                );
            }

            this.root.querySelector( '[data-id="invididualInput"]' ).addEventListener(
                'blur',
                ( event ) => {
                    const name = IF.Helper.trim( event.target.value );
                    this.setAttribute( 'name', name );
                    this._updateCheckedStatus();
                }
            );

            let icon = null;
            if ( this.hasAttribute( 'icons' ) && this.getAttribute( 'icons' ).length )
            {
                this.icons = this.getAttribute( 'icons' ).split( ",");
                icon = this.icons[ 0 ] + '.svg';
                this.root.querySelector( '[data-id="individual-item"]' ).setAttribute( 'src', 'assets/icons/routines/' + icon )
            }

            this.root.querySelector( '[data-id="individualItemSelector"]' ).addEventListener(
                'click',
                () => {
                    const wfContainer = this.app.gui.getIndividualItemModalContainer();

                    if ( this.hasAttribute( 'icons' ) && this.getAttribute( 'icons' ).length )
                    {
                        this.icons = this.getAttribute( 'icons' ).split( ",");
                        let iconCnt = 0;
                        wfContainer.querySelectorAll( '[data-type="individualItem"]' ).forEach( btn =>
                        {
                            if ( iconCnt < this.icons.length )
                            {
                                btn.setAttribute( 'data-item-src', this.icons[ iconCnt ] + '.svg' );
                                btn.querySelector( 'img' ).setAttribute( 'src', 'assets/icons/routines/' + this.icons[ iconCnt ] + '.svg' );
                                iconCnt++;
                            }
                        });
                    }

                    wfContainer.querySelectorAll( '[data-type="individualItem"]' ).forEach( btn =>
                    {
                        btn.addEventListener( 'click', () => {
                            this._onItemSelection( btn.getAttribute( 'data-item-src' ) );
                        });
                    });
                    wfContainer.querySelector( '[data-type="modal-closer"]' ).addEventListener( 'click', () =>
                    {
                        wfContainer.querySelectorAll( '[data-type="individualItem"]' ).forEach( (btn) =>
                        {
                            btn.removeEventListeners( 'click' );
                        });
                        wfContainer.querySelector( '[data-type="modal-closer"]' ).removeEventListeners( 'click' );
                        this.app.gui.hideIndividualItemModalContainer();
                    });
                    // Add some delay to give browser the chance to update icons
                    setTimeout( () => {
                        this.app.gui.showIndividualItemModalContainer();
                    }, 250 );
                }
            );

            this._isConnected = true;
        }
    }

    _updateCheckedStatus()
    {
        let isChecked = false;
        if ( 0 < this.weeklyFrequence )
        {
            let name = this.getAttribute( 'name' );
            if ( name && name.length > 0 )
            {
                isChecked = true;
            }
        }

        if ( true === isChecked )
        {
            this.setAttribute( 'checked', true );
        }
        else
        {
            this.removeAttribute( 'checked' );
        }
    }

    _onFrequenceSelection( times )
    {
        const wfContainer = this.app.gui.getIndividualItemModalContainer();
        wfContainer.querySelectorAll( '[data-type="weeklyFrequenceButton"]' ).forEach( (btn) =>
        {
            btn.removeEventListeners( 'click' );
        });
        this.setAttribute( 'weekly-frequence', times );
        this._updateCheckedStatus();
        this.app.gui.hideFrequenceModal();
    }

    _onItemSelection( itemSrc )
    {
        const wfContainer = this.app.gui.getIndividualItemModalContainer();
        wfContainer.querySelectorAll( '[data-type="individualItem"]' ).forEach( (btn) =>
        {
            btn.removeEventListeners( 'click' );
        });
        this.setAttribute( 'icon', itemSrc );
        this.app.gui.hideIndividualItemModalContainer();
    }

    disconnectedCallback()
    {}

    attributeChangedCallback( name, oldVal, newVal )
    {
        if ( this._isConnected )
        {
            if ( name === 'weekly-frequence' )
            {
                this.root.querySelector( '[data-id="container-weekly-frequence"]' ).innerHTML = newVal;
            }
            else if ( name === 'icon' )
            {
                this.root.querySelector( '[data-id="individual-item"]' ).setAttribute( 'src', 'assets/icons/routines/' + newVal )
            }
            else if ( name === 'name' )
            {
                // Do nothing
            }
            else if ( name === 'checked' )
            {
                // Do nothing
            }
            else
            {
                this.render();
            }
        }
    }

    render()
    {
        this.root.innerHTML = this.app.view.getHtml(
            template,
            {
                weeklyFrequence : this.hasAttribute( 'goal' ) && Routine.GOAL_DAILY === this.getAttribute( 'goal' ) ? 7 : this.weeklyFrequence,
                goal : this.getAttribute( 'goal' ),
                icon : this.getAttribute( 'icon' ),
                disableWeeklyFrequence : this.hasAttribute( 'goal' ) && Routine.GOAL_DAILY === this.getAttribute( 'goal' )
            }
        );
    }

}

customElements.define('routine-selection-individual', RoutineSelectionIndividual );
